export default function QuestionError() {
	return (
		<div>
			Por el momento los servicios no encuetran disponbiles, intente mas tarde.
		</div>
	);
}
